export class AddCharacteristicPayload {
  name: string;
}
